import { FC, useId } from 'react';
import { twMerge } from 'tailwind-merge';

import { IconProps } from './icon.types';

type WorkspaceFolderIconProps = {
  // The inner shadow along the folder's top edge, as `#RRGGBB`.
  shadowColor?: string;
} & IconProps;

// An feColorMatrix that paints the shadow's alpha in one flat colour.
const shadowMatrix = (hex: string): string => {
  const [red, green, blue] = [1, 3, 5].map(
    (start) => parseInt(hex.slice(start, start + 2), 16) / 255,
  );

  return `0 0 0 0 ${red} 0 0 0 0 ${green} 0 0 0 0 ${blue} 0 0 0 1 0`;
};

export const WorkspaceFolderIcon: FC<WorkspaceFolderIconProps> = ({
  iconColor = '#78A6EF',
  shadowColor = '#548CE4',
  className,
  ...props
}) => {
  const rawId = useId().replace(/:/g, '');
  const clipId = `${rawId}-workspace-folder-clip`;
  const filterId = `${rawId}-workspace-folder-filter`;

  return (
    <svg
      className={twMerge('shrink-0', className)}
      fill="none"
      height="32"
      viewBox="0 0 32 32"
      width="32"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath={`url(#${clipId})`}>
        <g filter={`url(#${filterId})`}>
          <path
            d="M12 5.33398H6.66667C5.95942 5.33398 5.28115 5.61494 4.78105 6.11503C4.28095 6.61513 4 7.29341 4 8.00065V22.6673C4 23.3746 4.28095 24.0528 4.78105 24.5529C5.28115 25.053 5.95942 25.334 6.66667 25.334H25.3333C26.0406 25.334 26.7189 25.053 27.219 24.5529C27.719 24.0528 28 23.3746 28 22.6673V12.0007C28 11.2934 27.719 10.6151 27.219 10.115C26.7189 9.61494 26.0406 9.33398 25.3333 9.33398H16L12 5.33398Z"
            fill={iconColor}
          />
        </g>
      </g>
      <defs>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="20"
          id={filterId}
          width="24"
          x="4"
          y="5.33398"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" mode="normal" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="-1.33333" />
          <feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic" />
          <feColorMatrix type="matrix" values={shadowMatrix(shadowColor)} />
          <feBlend in2="shape" mode="normal" result="effect1_innerShadow" />
        </filter>
        <clipPath id={clipId}>
          <rect fill="white" height="32" width="32" />
        </clipPath>
      </defs>
    </svg>
  );
};
